module.exports = __webpack_public_path__ + "img/index-banner.2be19e2c.jpg";